import { setTheme } from "theme/default/setTheme";

export const borderRadius_5px = setTheme(({ theme }) => theme.borderRadius.border_radius_5px);
